import { computed } from "vue";
import { Capacitor } from "@capacitor/core";

export const usePWADetection = () => {
  const isNativeApp = Capacitor.isNativePlatform();
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
  const ua = navigator.userAgent;

  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  // WebView empaquetado (algunos builds); Capacitor no siempre incluye "wv" en el UA
  const isAndroidWebView =
    /wv/.test(ua) || /Capacitor/i.test(ua) || isNativeApp;

  const isPWAMobile = computed(() => {
    if (isNativeApp) return true;
    return (isStandalone || isAndroidWebView) && isMobileUA;
  });

  const isSmallViewport = computed(() => window.innerHeight < 650);

  const shouldShowBackButton = computed(() => {
    return !isPWAMobile.value && !isSmallViewport.value;
  });

  return { isPWAMobile, shouldShowBackButton, isNativeApp };
};
